module.exports = __webpack_public_path__ + "static/media/template-products-event.8af72a9d.csv";